import { IsString, IsBoolean, IsOptional, IsDefined, IsIn, IsNumber } from 'class-validator';

const INPUT_TYPE_VALUES = ['email'] as const;

export class FormEmailFieldPropsDto {
  @IsOptional()
  @IsString()
  id?: string;

  @IsDefined()
  @IsIn([...INPUT_TYPE_VALUES])
  inputType!: (typeof INPUT_TYPE_VALUES)[number];

  @IsDefined()
  @IsString()
  label!: string;

  @IsDefined()
  @IsBoolean()
  showLabel!: boolean;

  @IsDefined()
  @IsString()
  placeholder!: string;

  @IsDefined()
  @IsBoolean()
  required!: boolean;

  @IsDefined()
  @IsBoolean()
  hidden!: boolean;

  @IsDefined()
  @IsString()
  helpText!: string;

  @IsDefined()
  @IsBoolean()
  showHelpText!: boolean;

  @IsDefined()
  @IsBoolean()
  enforceCharacterLimit!: boolean;

  @IsOptional()
  @IsNumber()
  minCharacterLimit?: number | null;

  @IsOptional()
  @IsNumber()
  maxCharacterLimit?: number | null;

  @IsOptional()
  @IsString()
  urlMapping?: string;

  @IsOptional()
  @IsBoolean()
  primaryEmailField?: boolean;
}
